module.exports = __webpack_public_path__ + "img/ceo4.4feb89cd.jpg";